/**
 * Created by wwei on 2018-01-05.
 */

import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Settings from "./common/Settings";
import { URL, ROLES } from "./common/Constants";

import { permissionCheck, roleCheck } from "./common/permission/PermissionCtrl";

import { saveGAView } from "./common/functions/GAUtils";
import Panel from "./common/components/Panel";
import TopBar from "./common/struct/TopBar";

class LandingPage extends React.Component {
  componentDidMount() {
    saveGAView("/");
  }

  render() {
    const apps = [
      {
        title: "CLOUD_APPS.PDMSSP.TITLE",
        description: "CLOUD_APPS.PDMSSP.DESCRIPTION",
        icon: "img/app-icon-pdmssp.svg",
        url: `${this.props.systemConfigs.pdmssp}/obinet/?sso=true`,
        access: {
          permissions: [],
          roles: [ROLES.PDMSSP_ADMIN.value, ROLES.PDMSSP_USER.value],
          entitlements: ["PDMS-SP UCS OBI", "PDMS-SP UCS", "PDMS-SP ZT"],
          features: ["showPDMSSPApp"]
        },
        id: "pdms_sp_link"
      },
      {
        title: "CLOUD_APPS.PDMSE.TITLE",
        description: "CLOUD_APPS.PDMSE.DESCRIPTION",
        icon: "img/app-icon-pdmse.svg",
        url: `${
          this.props.systemConfigs.pdmse
        }/api/rest/v1/user/login?tid=${sessionStorage.getItem(
          "tenantId"
        )}&email=${sessionStorage.getItem("username")}`,
        access: {
          permissions: [],
          roles: [ROLES.DEVICE_ADMIN.value, ROLES.DEVICE_OPERATOR.value],
          entitlements: [],
          features: ["showPDMSEApp"]
        },
        id: "pdms_e_link"
      },
      {
        title: "CLOUD_APPS.PDMSEDEV.TITLE",
        description: "CLOUD_APPS.PDMSEDEV.DESCRIPTION",
        icon: "img/app-icon-pdmse.svg",
        url: `${Settings.PDMS_DEV_URL}?tid=${sessionStorage.getItem(
          "tenantId"
        )}&email=${sessionStorage.getItem("username")}`,
        access: {
          permissions: [],
          roles: [],
          entitlements: [],
          features: ["showTempPdms"]
        },
        id: "pdms_e_devel_link"
      },
      {
        title: "CLOUD_APPS.PLANTRONICS.TITLE",
        description: "CLOUD_APPS.PLANTRONICS.DESCRIPTION",
        icon: "img/app-icon-plantronics.svg",
        url: "https://plt.demo.pltzone.org",
        access: {
          permissions: [],
          roles: [],
          entitlements: [],
          features: ["showPlantronicsApp"]
        },
        id: "plantronics_link"
      },
      {
        title: "CLOUD_APPS.REALCONNECT.TITLE",
        description: "CLOUD_APPS.REALCONNECT.DESCRIPTION",
        icon: "img/app-icon-realconnect.svg",
        url: URL.CLOUDSVC.REALCONNECT,
        access: {
          permissions: [],
          roles: [
            ROLES.ENTERPRISE_ADMIN.value,
            ROLES.LICENSE_ADMIN.value,
            ROLES.USER_ADMIN.value
          ],
          entitlements: [],
          features: ["showRealConnectApp"]
        },
        id: "real_connect_link"
      },
      {
        title: "CLOUD_APPS.ONETOUCHDIAL.TITLE",
        description: "CLOUD_APPS.ONETOUCHDIAL.DESCRIPTION",
        icon: "img/app-icon-otd.svg",
        url: URL.CLOUDSVC.OTD,
        access: {
          permissions: [],
          roles: [ROLES.OTD_ADMIN.value],
          entitlements: ["OTD"],
          features: ["showOneTouchDialApp"]
        },
        id: "one_touch_link"
      },
      {
        title: "CLOUD_APPS.A4B.TITLE",
        description: "CLOUD_APPS.A4B.DESCRIPTION",
        icon: "img/app-icon-amazon.svg",
        url: URL.A4B.AMAZON_ACCOUNT,
        access: {
          permissions: [],
          roles: [
            ROLES.ENTERPRISE_ADMIN.value,
            ROLES.DEVICE_ADMIN.value,
            ROLES.DEVICE_OPERATOR.value
          ],
          entitlements: [],
          features: ["showA4BApp"]
        },
        id: "a4b_link"
      },
      {
        title: "CLOUD_APPS.DA.TITLE",
        description: "CLOUD_APPS.DA.DESCRIPTION",
        icon: "img/app-icon-device-analytics.svg",
        url: this.props.systemConfigs.daUrl,
        access: {
          permissions: [],
          roles: [ROLES.DEVICE_ADMIN.value, ROLES.DEVICE_OPERATOR.value],
          entitlements: ["DA-SP", "DA-E", "DA"],
          features: ["showDA"]
        },
        id: "device_analytic_link"
      },
      {
        title: "CLOUD_APPS.AQUAANALYTICS.TITLE",
        description: "CLOUD_APPS.AQUAANALYTICS.DESCRIPTION",
        icon: "img/app-icon-realconnect-analytics.svg",
        url: "https://rc-reports.plcm.vc/",
        access: {
          permissions: [],
          roles: [
            ROLES.ENTERPRISE_ADMIN.value,
            ROLES.LICENSE_ADMIN.value,
            ROLES.USER_ADMIN.value
          ],
          entitlements: [],
          features: ["showAquaAnalyticsApp"]
        },
        id: "aqua_analytics_link"
      },
      {
        title: "CLOUD_APPS.REALACCESS.TITLE",
        description: "CLOUD_APPS.REALACCESS.DESCRIPTION",
        icon: "img/app-icon-realaccess.svg",
        url: "https://realaccess.polycom.com",
        access: {
          permissions: [],
          roles: [
            ROLES.ENTERPRISE_ADMIN.value,
            ROLES.LICENSE_ADMIN.value,
            ROLES.USER_ADMIN.value
          ],
          entitlements: [],
          features: ["showRealAccessApp"]
        },
        id: "real_access_link"
      },
      {
        title: "CLOUD_APPS.CLOUDDEVICES.TITLE",
        description: "CLOUD_APPS.CLOUDDEVICES.DESCRIPTION",
        icon: "img/app-icon-cloud-devices.svg",
        url: URL.TENANT_PORTAL.CLOUD_DEVICES,
        access: {
          permissions: [],
          roles: [ROLES.DEVICE_ADMIN.value, ROLES.DEVICE_OPERATOR.value],
          entitlements: [],
          features: ["showCloudDevicesApp"]
        },
        id: "register_device_link"
      },
      {
        title: "CLOUD_APPS.ADMINISTRATION.TITLE",
        description: "CLOUD_APPS.ADMINISTRATION.DESCRIPTION",
        icon: "img/app-icon-admin.svg",
        url: URL.TENANT_PORTAL.ACCOUNT_CODE,
        access: {
          permissions: [],
          roles: [
            ROLES.ENTERPRISE_ADMIN.value,
            ROLES.LICENSE_ADMIN.value,
            ROLES.USER_ADMIN.value
          ],
          entitlements: [],
          features: ["showAdministrationApp"]
        },
        id: "admin_link"
      },
      {
        title: "CLOUD_APPS.SUPPORT.TITLE",
        description: "CLOUD_APPS.SUPPORT.DESCRIPTION",
        icon: "img/app-icon-support.svg",
        url: "https://cloudsupport.polycom.com/Services/",
        access: {
          permissions: [],
          roles: [],
          entitlements: [],
          features: ["showSupportApp"]
        },
        target: "_blank",
        id: "support_link"
      }
    ];

    const t = this.props.t;

    this.activeApps = apps.filter(app => {
      const features = app.access.features.every(
        flag => this.props.featureConfigs[flag]
      );
      const permissions =
        app.access.permissions.some(perm => permissionCheck(perm)) ||
        app.access.permissions.length === 0;
      const entitlements =
        app.access.entitlements.length === 0
          ? true
          : app.access.entitlements.some(ent =>
              this.props.entitlements.includes(ent)
            );
      const roles =
        app.access.roles.some(role => roleCheck(role)) ||
        app.access.roles.length === 0;

      return features && permissions && entitlements && roles;
    });
    return (
      <div className="page-landing">
        <TopBar history={this.props.history} noMenu={true} title="" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100%"
          }}
        >
          <div
            className="main-container"
            style={{
              maxWidth: (250 + 10 + 10) * 4,
              minHeight: "91vh"
            }}
          >
            {this.activeApps.map((app, index) => {
              return (
                <a
                  key={index}
                  href={app.url}
                  style={{ display: "table" }}
                  id={app.id}
                  target={app.target ? app.target : "_self"}
                >
                  <Panel
                    style={{
                      lineHeight: 1,
                      background: "#fff",
                      borderRadius: "8px",
                      width: 250,
                      height: 250,
                      minWidth: 250,
                      minHeight: 250,
                      textAlign: "center"
                    }}
                  >
                    <img
                      alt=""
                      src={app.icon}
                      style={{ height: 140, width: 140 }}
                    />
                    <div className="landing_icon">
                      <h3>{t(app.title)}</h3>
                      <small>{t(app.description)}</small>
                    </div>
                  </Panel>
                </a>
              );
            })}
          </div>
          <div className="footer">
            <span className="text-muted">
              {t("FOOTER.COPYRIGHT_CONTENT", {
                year: new Date().getFullYear()
              })}
            </span>
            <br />
            <a
              href={Settings.LICENSE_AGREEMENT_URL}
              style={{ color: "#3c99d1", marginRight: 8 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("FOOTER.TERMS_OF_SERVICE")}
            </a>
            |
            <a
              href={Settings.PRIVACY_URL}
              style={{ color: "#3c99d1", marginLeft: 8 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("FOOTER.PRIVACY_POLICY")}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  featureConfigs: state.config.featureConfigs,
  entitlements: state.config.entitlements,
  systemConfigs: state.config.systemConfigs
});
export default translate()(connect(mapStateToProps)(LandingPage));



// WEBPACK FOOTER //
// ./src/LandingPage.js